module.exports = __webpack_public_path__ + "img/logo-icon-app.fb2024d0.png";